import BaseTableNew from 'components/atoms/base-table/new';
import { useMemo } from 'react';

import { defaultCols } from './cols/defaultColumns';

import type { IClinicListFilters } from 'infrastructure/interfaces';
import type { MergedMeta } from 'infrastructure/hooks/clinic/use-admin-clinic-list';
import type { Clinic } from 'infrastructure/classes/clinic';

interface IProps {
  loading: boolean;
  meta: MergedMeta;
  clinics: Clinic[];
  filters: IClinicListFilters;
  onChangePage: (page: number) => void;
}

export default function DefaultViewTable({
  meta,
  filters,
  clinics,
  loading,
  onChangePage,
}: IProps) {
  const defaultColumns = useMemo(
    () => defaultCols({ page: filters.page }),
    [filters.page],
  );
  return (
    <BaseTableNew
      rowKey="guid"
      dataCy="clinics-default-table"
      items={clinics}
      columns={defaultColumns ?? []}
      loading={loading}
      pagination={{
        current: filters.page ?? 1,
        pageSize: meta.items,
        total: meta.totalCount,
        position: ['bottomCenter'],
      }}
      bordered
      onChangePage={onChangePage}
      anchor
    />
  );
}
